module.exports = __webpack_public_path__ + "img/usps.3d43c1ee.svg";